import React from 'react';
import Container from '../../../../../Common/Container/Container';
import ContentNotFoundImage from '../../../../../../assets/images/content-not-found-modern.inline.svg';
import * as classes from './ContentNotFoundSection.module.scss';
import { useTranslation } from 'gatsby-plugin-react-i18next';

const ContentNotFoundSection = () => {
  const { t } = useTranslation();

  return (
    <section>
      <Container className={classes.wrapper}>
        <div className={classes.inner}>
          <ContentNotFoundImage />
          <div className={classes.text}>{t('additionalInfo.contentNotFoundSection.titleText')}</div>
        </div>
      </Container>
    </section>
  );
};

export default ContentNotFoundSection;
